module.exports = __webpack_public_path__ + "static/img/6.f7d2dde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/6.png
// module id = LTUP
// module chunks = 2